import "../Css/groovePQR_pdf.css"
import Groove_pdf_header_common from "../../../WPSTransaction/PDF/Pages/Groove_pdf_header_common";

const TTS_pdf_header_common = ({ pdf, pageType }) => {
  const currentDate = new Date(pdf[0]?.PQR_Date);
  const day = currentDate.getDate();
  const month = currentDate.getMonth() + 1;
  const year = currentDate.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;

  const renderTableContent = () => {
    if (pageType === 1) {
      return (
        <tr>
          <th style={{ width: "28%", borderTop: "1px solid", borderBottom: "1px solid", borderRight: "1px solid", borderLeft: "1px solid" }}>
            PQR record number<br />Date<br />Qualification Code
          </th>
          <td style={{ width: "40%", borderTop: "1px solid", borderBottom: "1px solid" }}>
            <span className="WPSforfont" style={{ float: "left" }}>{pdf[0]?.PQR_RecordNo}</span><br />
            <span className="WPSforfont" style={{ float: "left" }}>{formattedDate === "NaN-NaN-NaN" ? "" : formattedDate}</span><br />
            <span className="WPSforfont" style={{ float: "left" }}>{pdf[0]?.PQR_Qualificationcode}</span>
          </td>
          <th className="WPSright-th" style={{ width: "32%", borderLeft: "1px solid", borderBottom: "1px solid", borderTop: "1px solid", borderRight: "1px solid", paddingTop: "0px", position: "relative" }}>
            WPS Record Number<br />Company Name<br />Address<br />
          </th>
          <td style={{ width: "55%", borderTop: "1px solid", borderBottom: "1px solid" }}>
            <span className="WPSforfont" style={{ float: "left" }}>{pdf[0]?.PQR_pWPSNo}</span>
            <div className="PQRcorner">Revision: {pdf[0]?.PQR_WPS_ReviNo}</div><br />
            <span className="WPSforfont" style={{ float: "left" }}>{pdf[0]?.PQR_CompanyName}<br /></span><br />
            <span className="WPSforfont" style={{ float: "left" }}>{pdf[0]?.PQR_Address}<br /></span><br />
          </td>
          <td style={{ width: "35%", borderTop: "1px solid", borderBottom: "1px solid", borderRight: "1px solid" }}>
            {pdf[0]?.WPS_QualifiedTo}<br />{pdf[0]?.WPSH_CompanyName}<br />
          </td>
        </tr>
      );
    } else {
      return (
        <tr>
          <th style={{ width: "25%", borderTop: "1px solid", borderBottom: "1px solid", borderRight: "1px solid", borderLeft: "1px solid", whiteSpace: pageType === 3 ? "nowrap" : "normal" }}>
            Welder Name<br />ID Number<br />
          </th>
          <td style={{ width: "45%", borderTop: "1px solid", borderBottom: "1px solid" }}>
            <span className="WPSforfont" style={{ float: "left", whiteSpace: "nowrap" }}>{pdf[0]?.PQR_Certification_Welder_Name}</span><br />
            <span className="WPSforfont" style={{ float: "left", whiteSpace: "nowrap" }}>{pdf[0]?.PQR_Certification_ID}</span>
          </td>
          <th className="WPSright-th" style={{ width: "25%", borderLeft: "1px solid", borderBottom: "1px solid", borderTop: "1px solid", borderRight: "1px solid" }}>
            Test Date<br />WPQ record Number
          </th>
          <td style={{ width: "35%", borderTop: "1px solid", borderBottom: "1px solid" }}>
            <span className="WPSforfont" style={{ float: "left", whiteSpace: pageType === 3 ? "nowrap" : "normal" }}>
              {formattedDate === "NaN-NaN-NaN" ? "" : formattedDate}<br />
            </span><br />
            <span className="WPSforfont" style={{ float: "left", whiteSpace: pageType === 3 ? "nowrap" : "normal" }}>
              {pdf[0]?.PQR_RecordNo}<br />
            </span>
          </td>
          <td style={{ width: "35%", borderTop: "1px solid", borderBottom: "1px solid", borderRight: "1px solid", whiteSpace: pageType === 2 ? "nowrap" : "normal" }}>
            {pdf[0]?.WPS_QualifiedTo}<br />{pdf[0]?.WPSH_CompanyName}
          </td>
        </tr>
      );
    }
  };

  return (
    <header>
      <Groove_pdf_header_common currentDate={currentDate} from="PQR" />
      <table id="table" className="WPSTable1" style={pageType === 3 ? { width: "570px" } : {}}>
        <tbody>
          {renderTableContent()}
        </tbody>
      </table>
    </header>
  );
};

export default TTS_pdf_header_common;